import useToast from "../../../hooks/ToastHook";

const currencyFormat = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const actionButtonsClasses = "m-0 px-6 align-content-center font-semibold text-black-500 cursor-pointer"

const Product = ({ index, productData, onClick }) => {
  const { showError } = useToast();
  const { 
    product, 
    quantity, 
    unit,
    unitaryValue
  } = productData;

  return (
    <div 
      className="
        flex
        border-1
        border-top-1
        border-200
        border-round-xl
        px-3
        py-5
      " 
    >
      <div className="flex-grow-1">
        <h3 className="m-0 text-sm font-semibold mb-2">{product?.description}</h3>
        <div className="flex gap-3">
          <div>Cód: {product.code}</div>
          <div>Valor: {currencyFormat.format(unitaryValue * quantity || 0)}</div>
          <div>Qtde: {quantity} {unit.symbol}</div>
        </div>
      </div>
      <div 
        className={actionButtonsClasses}
        onClick={() => onClick(index, 'general')}
      >
        Detalhes do produto
      </div>
      <div 
        className={actionButtonsClasses}
        onClick={() => {
          if(!product.description) {
            showError('Preencha os detalhes do produto antes de preencher o ICMS.');

            return;
          }

          onClick(index, 'icms');
        }}
      >
        <span>ICMS</span>
      </div>
    </div>
  );
}

const ProductsList = ({ products, onProductClick }) => {
  return (
    <div className="flex flex-column gap-4">
      {products.map((product, i) => (
        <Product key={i} index={i} productData={product} onClick={onProductClick} quantity={product.quantity} />
      ))}
    </div>
  );
}

export default ProductsList;